const API_GRAPHQL_URL = import.meta.env.VITE_API_GRAPHQL_URL || '';

export const getApiOrigin = () => {
	try {
		return new URL(API_GRAPHQL_URL).origin;
	} catch {
		return '';
	}
};

export const getFileDownloadUrl = (fileId) => {
	if (!fileId) return null;

	const origin = getApiOrigin();

	if (!origin) return null;

	return `${origin}/api/files/${fileId}`;
};
